import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { coachServices } from "../data/content";
export function Coaches() {
  return <section id="tecnicos" aria-labelledby="tecnicos-title" className="scroll-mt-20 bg-gold text-ink" data-id="element-32" data-mp="33un8zpn90odj">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-2 lg:gap-24 lg:px-8 lg:py-32" data-id="element-33" data-mp="3ij9kthdo2y00">
        <div data-id="element-34" data-mp="3dp5duy4eipyx">
          <p className="text-sm font-semibold" data-id="element-35" data-mp="3dpf3ulpg4x4m">Para entrenadores</p>
          <h2 id="tecnicos-title" className="mt-3 text-3xl font-semibold tracking-tight sm:text-5xl" data-id="element-36" data-mp="3rh22utarwjr3">
            Asesoramiento a técnicos de fútbol
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/85" data-id="element-37" data-mp="5boonn1px17l">
            Los entrenadores también necesitan una estructura que respalde su carrera. Acompañamos a técnicos y
            cuerpos técnicos con la misma visión de largo plazo que aplicamos con los jugadores: decisiones
            estratégicas, relaciones transparentes y presencia en cada etapa.
          </p>
          <a href="#contacto" className="mt-10 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-ink px-6 py-3 text-sm font-semibold text-paper shadow-md transition-[background-color,transform] duration-150 ease-out hover:bg-ink-soft active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-gold" data-id="element-38" data-mp="2p50ixf16u76y">
            Consultar como entrenador
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="37xchdqoq0obt" />
          </a>
        </div>

        <dl className="border-b border-ink/25" data-id="element-40" data-mp="3cvw6u12iwi8x">
          {coachServices.map(item => <div key={item.title} className="border-t border-ink/25 py-6" data-id="element-41" data-mp="3hr1ouost1crq">
              <dt className="text-lg font-semibold" data-id="element-42" data-mp="3lu7t5qwcwtvk">{item.title}</dt>
              <dd className="mt-2 leading-relaxed text-ink/80" data-id="element-43" data-mp="1nfwqo00hlsjs">{item.description}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}